export enum LogEventType {
  Information,
  Event,
  Error,
  Metric,
  Exception,
  Trace
}
